import { useLang } from "../OneHealthContext";
import { SCAN_DURATION_SEC } from "../config";

const asset = (p) => `${process.env.PUBLIC_URL || ""}${p}`;

/* GET STARTED — landing screen. Explains the contactless rPPG face scan and
   opens the flow. L&T / CarePlix branding sits in the device bezels. */
export default function GetStarted({ onStart }) {
  const { tr } = useLang();
  return (
    <div className="oh-view oh-getstarted">
      <div className="oh-spacer" />
      {/* In landscape (16:9) .oh-gs-split becomes a two-column row:
          text + points on the left, hero image on the right. In portrait
          it stays a single column in source order. */}
      <div className="oh-gs-split">
        <div className="oh-gs-main">
          <div className="oh-kicker">{tr("getstarted.kicker")}</div>
          <h1 className="oh-h1" style={{ marginTop: 14 }}>
            {tr("getstarted.title1")}<br />
            <span className="lite">{tr("getstarted.title2")}</span>
          </h1>
          <p className="oh-sub" style={{ marginTop: 18, maxWidth: 360 }}>
            {tr("getstarted.sub", { n: SCAN_DURATION_SEC })}
          </p>

          <div className="oh-gs-points">
            <div className="oh-note"><span className="b" />{tr("getstarted.p1")}</div>
            <div className="oh-note"><span className="b" />{tr("getstarted.p2")}</div>
            <div className="oh-note"><span className="b" />{tr("getstarted.p3")}</div>
          </div>
        </div>

        <div className="oh-gs-hero">
          <img src={asset("/brand/worker-hero.png")} alt="" aria-hidden="true" />
        </div>
      </div>

      <div className="oh-spacer" />
      <button className="oh-btn oh-btn-sm oh-gs-cta" onClick={onStart}>{tr("getstarted.cta")}</button>
      <div style={{ height: 12 }} />
      <p className="oh-foot">{tr("getstarted.foot")}</p>
    </div>
  );
}
